<template>
  <div
    :class="{'row':isRow}"
    class="detail-container">
    <div
      v-for="(item,index) in newForm"
      :class="{'rax':isRow}"
      :key="index">
      <p
        v-if="item.type==='title'"
        class="title">{{ item.label }}</p>
      <p
        v-if="item.type==='text'"
        class="text">{{ item.label?item.label+':':'' }} {{ item.value }}</p>
      <div
        v-else-if="item.type==='table'"
        class="table">
        <table
          border="1"
          borderColor="#f2f2f2"
        >
          <thead>
            <tr><td
              v-for="(item1,index1) in item.thead"
              :key="'th'+index1">{{ item1 }}</td></tr>
          </thead>
          <tbody>
            <tr
              v-for="(item2,index2) in item.value"
              :key="'tr'+index2">
              <td
                v-for="(item3,index3) in item2"
                :key="'td'+index3">{{ item3 }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "RowCell",
    props: {
      form: [Array, Object],
      isRow: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        newForm: this.form,
      };
    },
    watch: {
      form: {
        handler(vl) {
          this.newForm = vl;
        },
        deep: true,
        immediate: true,
      },
    },
  };
</script>

<style scoped>
  .row{
    display: flex;
    flex-direction: row;
  }
  .rax{
    width: 30%;
  }
  .title,.text{
    line-height: 30px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  .title{
    font-size: 16px;
    margin-top: 20px;
    line-height: 40px;
  }
</style>
